/**
 * @generated SignedSource<<ce313fc54f25c53e3192d5d1589d5f8f>>
 * @relayHash 87f697066ce5a3de618ea59bd466ef01
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 646dca6da61b50fad16ab00c711def1e3634d180c6f4dde51d4fd68783b8d80b

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type ReportsOverviewPageQuery$variables = {
  avpProjectKey: string;
  boardId: string;
  cloudId: string;
  isBoardContext: boolean;
  isMigrateTMPReportsOverviewEnabled: boolean;
  isRoiDashboardEnabled: boolean;
  isSunsetHideEnabled: boolean;
  projectKey: string;
  workspaceAri?: string | null;
};
export type ReportsOverviewPageQuery$data = {
  readonly jira: {
    readonly spaceDashboardAvpProject: {
      readonly projectId: string | null;
    } | null;
  } | null;
  readonly jira_projectByIdOrKey?: {
    readonly projectStyle: JiraProjectStyle | null;
    readonly projectType: JiraProjectType;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ReportCategories" | "SpaceDashboard_spaceDashboardQuery">;
};
export type ReportsOverviewPageQuery = {
  response: ReportsOverviewPageQuery$data;
  variables: ReportsOverviewPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "avpProjectKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "boardId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isBoardContext"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isMigrateTMPReportsOverviewEnabled"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isRoiDashboardEnabled"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSunsetHideEnabled"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceAri"
},
v9 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v10 = [
  (v9/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "avpProjectKey"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v12 = [
  (v9/*: any*/),
  {
    "kind": "Variable",
    "name": "idOrKey",
    "variableName": "projectKey"
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v14 = {
  "kind": "ScalarField",
  "name": "projectStyle"
},
v15 = {
  "kind": "ScalarField",
  "name": "id"
},
v16 = {
  "kind": "ScalarField",
  "name": "failureCode"
},
v17 = {
  "kind": "ScalarField",
  "name": "failureType"
},
v18 = {
  "kind": "ScalarField",
  "name": "hasAccess"
},
v19 = {
  "kind": "ScalarField",
  "name": "hasManage"
},
v20 = {
  "kind": "ScalarField",
  "name": "hasWrite"
},
v21 = {
  "kind": "ScalarField",
  "name": "key"
},
v22 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v23 = {
  "concreteType": "AVPPermissionsPropertyEntry",
  "kind": "LinkedField",
  "name": "properties",
  "plural": true,
  "selections": [
    (v21/*: any*/),
    {
      "kind": "LinkedField",
      "name": "value",
      "plural": false,
      "selections": [
        (v22/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "values"
            }
          ],
          "type": "AVPPermissionsPropertyValueList"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "value"
            }
          ],
          "type": "AVPPermissionsPropertyValueString"
        }
      ]
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "name": "reason"
},
v25 = {
  "kind": "ScalarField",
  "name": "name"
},
v26 = {
  "concreteType": "JiraReportCategoryEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "concreteType": "JiraReportCategoryNode",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v25/*: any*/),
        {
          "concreteType": "JiraReportConnection",
          "kind": "LinkedField",
          "name": "reports",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraReportConnectionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraReport",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v22/*: any*/),
                    (v25/*: any*/),
                    (v21/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "imageUrl"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "description"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "url"
                    },
                    (v15/*: any*/),
                    {
                      "condition": "isMigrateTMPReportsOverviewEnabled",
                      "kind": "Condition",
                      "passingValue": true,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "isNotApplicableReason"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "isNotApplicableDesc"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        (v15/*: any*/)
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ReportsOverviewPageQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "ReportCategories"
      },
      {
        "kind": "FragmentSpread",
        "name": "SpaceDashboard_spaceDashboardQuery"
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "spaceDashboardAvpProject",
            "args": (v10/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v11/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "isBoardContext",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": (v12/*: any*/),
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "jira_projectByIdOrKey",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v13/*: any*/),
                  "action": "THROW"
                },
                (v14/*: any*/)
              ]
            },
            "action": "THROW"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReportsOverviewPageQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "spaceDashboardAvpProject",
            "args": (v10/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v15/*: any*/),
              {
                "condition": "isRoiDashboardEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v13/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "args": [
          {
            "fields": [
              (v9/*: any*/),
              {
                "kind": "Variable",
                "name": "workspaceAri",
                "variableName": "workspaceAri"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "AVPPermissionsGetCapabilitiesResponse",
        "kind": "LinkedField",
        "name": "avpPermissions_getCapabilities",
        "plural": false,
        "selections": [
          {
            "concreteType": "AVPPermissionsCapabilityResult",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "capabilityId"
              },
              {
                "concreteType": "AVPPermissionsHasCapabilityResponse",
                "kind": "LinkedField",
                "name": "result",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  {
                    "concreteType": "AVPPermissionsProductCapabilityResult",
                    "kind": "LinkedField",
                    "name": "productResults",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "productId"
                      },
                      {
                        "concreteType": "AVPPermissionsProductCapabilityResponse",
                        "kind": "LinkedField",
                        "name": "result",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v23/*: any*/),
                  (v24/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isBoardContext",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v12/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jira_projectByIdOrKey",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraReportCategoryConnection",
                "kind": "LinkedField",
                "name": "reportCategories",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": true,
                        "selections": [
                          (v22/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "statusCode"
                          }
                        ]
                      }
                    ]
                  },
                  (v26/*: any*/)
                ]
              },
              (v15/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "isBoardContext",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "boardId"
                  }
                ],
                "kind": "LinkedField",
                "name": "jiraBoard",
                "plural": false,
                "selections": [
                  (v22/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "JiraReportCategoryConnection",
                        "kind": "LinkedField",
                        "name": "reportCategories",
                        "plural": false,
                        "selections": [
                          (v26/*: any*/)
                        ]
                      }
                    ],
                    "type": "JiraBoard"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v15/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "646dca6da61b50fad16ab00c711def1e3634d180c6f4dde51d4fd68783b8d80b",
    "metadata": {},
    "name": "ReportsOverviewPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9637bfe5f20f1843967da64de2b15a3d";

export default node;
